import { call, CallEffect, put, PutEffect } from 'redux-saga/effects';
import { toErrorType } from 'commons/src/sagas/isErrorType';
import {
    FetchPublicRadonResponse,
    fetchPublicRadonDataSuccess,
    fetchPublicRadonDataError,
    FetchPublicRadonDataSuccess,
    FetchPublicRadonDataError,
} from '../actions/actions';
import { getPublicRadonData } from '../api/publicDevice';

type FetchPublicRadonDataSagaActionType = Generator<
    | CallEffect<{ data: FetchPublicRadonResponse }>
    | PutEffect<FetchPublicRadonDataSuccess>
    | PutEffect<FetchPublicRadonDataError>,
    void,
    { data: FetchPublicRadonResponse }
>;
export function* fetchPublicRadonDataSaga(payload: { geoHash: string }): FetchPublicRadonDataSagaActionType {
    try {
        const response: { data: FetchPublicRadonResponse } = yield call(getPublicRadonData, payload);
        yield put(fetchPublicRadonDataSuccess(response.data));
    } catch (error) {
        const errorAsErrorType = toErrorType(error);
        yield put(fetchPublicRadonDataError(errorAsErrorType.error));
    }
}

export default fetchPublicRadonDataSaga;
